import React, { useState } from 'react';
import { Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import "./AdminLayout.css";
import { AdminMenu, Logout } from "../../components/Admin/AdminLayout"

export function AdminLayout(props) {
  const { children } = props;
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className='admin-layout'>
      <div className={`admin-layout__left ${sidebarOpen ? 'open' : ''}`}>
        <AdminMenu onToggle={toggleSidebar} />
      </div>
      <div className='admin-layout__right'>
        <div className='admin-layout__right-header'>
          <Logout toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
        </div>
        <div className='admin-layout__right-content'>
          {children}
        </div>
      </div>
      {sidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
    </div>
  )
}